import axios from "axios";
// import { signInWithEmailAndPassword } from "firebase/auth";

import { setUserCredentials, getUserCredentials } from "../utils/common";
import { API_URL_AUTH } from "../utils/Constant";
// import firebaseAuth from "../utils/firebase";

// Commented out - using direct backend auth
// export const validEmail = async (email, callback) => {
//   firebaseAuth
//     .fetchSignInMethodsForEmail(email)
//     .then((signInMethods) => {
//       if (signInMethods && signInMethods.length > 0) {
//         callback({ success: true });
//       } else {
//         callback({ success: false });
//       }
//     })
//     .catch((error) => {
//       callback({
//         success: false,
//         message: error.message || "something went wrong",
//       });
//     });
// };

// export const getUserDetailsByToken = async (idToken) => {
//   try {
//     const params = {
//       token: idToken,
//     };
//     const result = await axios.get(`${API_URL_AUTH}/login/`, { params });
//     const data = result.data;
//     return {
//       success: data.message === "Success",
//       data: (data && data.result) || {},
//       message: data.message,
//     };
//   } catch (e) {
//     const message = e.response?.data?.message ?? e.message;
//     return {
//       success: false,
//       message: message || "Something went wrong",
//     };
//   }
// };

/**
 * Login function that calls backend /login/ API
 * @param {string} email user email
 * @param {string} password user password
 * @returns {Promise<Object>} { success, data, message }
 */
export const signIn = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL_AUTH}/login/`, {
      user_email: email,
      password,
    });

    const { message, result } = response.data;

    if (message === "Success" && result) {
      const data = {
        ...result,
      };
      // Store main user credentials in sessionStorage
      setUserCredentials("session", data, null);

      return { success: true, data };
    }
    return {
      success: false,
      message: message || "Login failed",
    };
  } catch (e) {
    const message = e.response?.data?.message ?? e.message ?? "Something went wrong";
    return {
      success: false,
      message,
    };
  }
};

// Commented out - Old Firebase-based login
// export const signIn = async (email, password) => {
//   try {
//     const response = await signInWithEmailAndPassword(firebaseAuth, email, password);
//     const { user } = response;
//     const idToken = user.accessToken;

//     const result = await getUserDetailsByToken(idToken);
//     if (!result.success) return result;

//     const data = {
//       ...result.data,
//       uid: user.uid || "",
//       email: user.email || "",
//       phoneNumber: user.phoneNumber || "",
//       displayName: user.displayName || "",
//       photoURL: user.photoURL || "",
//       idToken,
//     };

//     const isValidUser = await authenticateUserPayload(result.data.user_payload);
//     if (!isValidUser.success) {
//       return { success: false, message: "Invalid user" };
//     }

//     setUserCredentials(data);
//     return { success: true, data };
//   } catch (error) {
//     return {
//       success: false,
//       message: error?.response?.data?.message || "Something went wrong",
//     };
//   }
// };

// Commented out - Not needed for login flow only
// export const authenticateUserPayload = async (user_payload) => {
//   try {
//     const response = await axios.get(
//       `${API_URL}/supportloginconfig/`,
//       { params: { user_payload } }, // Include user parameter only if provided
//     );
//     return { success: true, data: response.data.result };
//   } catch (error) {
//     // eslint-disable-next-line
//     console.error("Error fetching user configuration:", error);
//     throw error;
//   }
// };

/**
 * Refresh Firebase token using refresh token
 * @returns {Object} { success, firebase_id_token, firebase_refresh_token, expires_in, message }
 */
export const refreshToken = async () => {
  try {
    // Get refresh token from user_details (stored via setUserCredentials)
    const userCredentials = getUserCredentials();
    const refreshTokenValue = userCredentials?.firebase_refresh_token;

    if (!refreshTokenValue) {
      return {
        success: false,
        message: "No refresh token available",
      };
    }

    const response = await axios.post(
      `${API_URL_AUTH}/login/refresh/`,
      {
        refresh_token: refreshTokenValue,
        disableInterceptor: true, // Bypass interceptor to avoid adding expired token and user payload
      },
    );

    const { message, result } = response.data;

    if (message === "Success" && result) {
      const { firebase_id_token, firebase_refresh_token, expires_in } = result;

      // Get current credentials (should always exist if refresh was called)
      const currentCredentials = getUserCredentials();

      if (!currentCredentials) {
        // Edge case: credentials missing but refresh succeeded
        // This shouldn't happen in normal flow, but handle gracefully
        return {
          success: false,
          message: "User credentials not found. Please log in again.",
        };
      }

      // Update main credentials in sessionStorage with new token
      // This ensures token synchronization across the app
      const updatedCredentials = {
        ...currentCredentials,
        firebase_id_token,
        firebase_refresh_token,
        expires_in: expires_in ? String(expires_in) : currentCredentials.expires_in,
      };
      setUserCredentials("session", updatedCredentials, null);

      return {
        success: true,
        firebase_id_token,
        firebase_refresh_token,
        expires_in: String(expires_in),
      };
    }

    return {
      success: false,
      message: message || "Token refresh failed",
    };
  } catch (e) {
    const errorDetail = e.response?.data?.detail;
    const errorMessage = e.response?.data?.message;
    const isTokenExpired = errorDetail === "Token has expired." || errorMessage === "Token has expired.";

    const message = errorMessage ?? errorDetail ?? e.message ?? "Token refresh failed";

    // If refresh token itself is expired, return a specific error
    if (isTokenExpired) {
      return {
        success: false,
        message: "Refresh token has expired. Please log in again.",
        refreshTokenExpired: true,
      };
    }

    return {
      success: false,
      message,
      refreshTokenExpired: false,
    };
  }
};
